import React from "react";
import SEO from "../SEO/SEO";
import HeroBanner from "./HeroBanner";
import AirportService from "./AirportService";
import Transferts from "./Transferts";
import AirportRides from "./AirportRides";
import HomeContact from "./Contact";

const Home = () => {
  return (
    <div>
      <SEO
        title="Home - RS Transports - transfert airports Paris Orly CDG and Beauvais to Disnesland"
        description="Experience the elegance of our premium vehicles driven by professional chauffeurs."
        keywords="transport, airport transfers, paris, premium vehicles"
      />
      
        <HeroBanner />
        <AirportService />
        <Transferts />
        <AirportRides />
        <HomeContact />
    </div>
  );
};

export default Home;
